import { httpClient } from '../../../../Common/api/http_client';

// Category APIs
// ========================
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function getProductsCategories() {
  return httpClient.get('/merchant/category');
}

/**
 *
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 */
export function createCategory(data) {
  return httpClient.post('/merchant/category', data);
}

/**
 *
 * @param data
 * @param categoryId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateCategory(data, categoryId) {
  return httpClient.put(`/merchant/category/${categoryId}`, data);
}

/**
 *
 * @param categoryId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteCategory(categoryId) {
  return httpClient.delete(`/merchant/category/${categoryId}`);
}

// SubCategory APIs
// ========================
/**
 *
 * @returns {Promise<AxiosResponse<T>>}
 */
export function createSubCategory(data) {
  return httpClient.post('/merchant/subcategory', data);
}

/**
 *
 * @param data
 * @param subCategoryId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateSubCategory(data, subCategoryId) {
  return httpClient.put(`/merchant/subcategory/${subCategoryId}`, data);
}

/**
 *
 * @param subCategoryId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteSubCategory(subCategoryId) {
  return httpClient.delete(`/merchant/subcategory/${subCategoryId}`);
}

// MicroCategory APIs
// ========================
/**
 *
 * @param data
 * @returns {Promise<AxiosResponse<T>>}
 */
export function createMicroCategory(data) {
  return httpClient.post('/merchant/microcategory', data);
}

/**
 *
 * @param data
 * @param microCategoryId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function updateMicroCategory(data, microCategoryId) {
  return httpClient.put(`/merchant/microcategory/${microCategoryId}`, data);
}

/**
 *
 * @param microCategoryId
 * @returns {Promise<AxiosResponse<T>>}
 */
export function deleteMicroCategory(microCategoryId) {
  return httpClient.delete(`/merchant/microcategory/${microCategoryId}`);
}
